import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { StaticPagesList } from './components/StaticPagesList';
import { StaticPageForm } from './components/StaticPageForm';
import SingleStaticPage from './single';

const StaticPagesRoutes = () => {
  return (
    <Routes>
      <Route path='/' element={<StaticPagesList />} />
      <Route path='edit/:id' element={<StaticPageForm />} />
      <Route path=':id' element={<SingleStaticPage />} />
      <Route path='*' element={<Navigate to='/' replace />} />
    </Routes>
  );
};

export default StaticPagesRoutes; 